// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common: {
    yes: "Yes",
    no: "No",
    na: "N/A",
    
    good: "Good",
    satisfactory: "Satisfactory",
    poor: "Poor",
    
    shgs: "SHGs",
    others: "Others",
    
    other: "Other",
    other_material: "Other Material",
    other_materials: "Other Materials",
    
    not_applicable: "Not Applicable",
    
    thermocol_plates: "Thermocol Plates",
    aluminium_foil_plates: "Aluminium Foil Plates",
    aluminium_foil_packets: "Aluminium Foil Packets",
    
    steel_plates: "Steel Plates",
    plastic_plates: "Plastic Plates",
    
    single_use_plastic_containers: "Single Use Plastic Containers",
    
    remarks: "Remarks",
    
    from: "From",
    to: "To",
    
    capture_or_upload_photo: "Capture or Upload Photo",
    
    upload_document: "Upload Document",
    upload_supporting_file: "Upload Supporting File",
    
    last_refill_date: "Last Refill Date",
    last_pest_control_date: "Last Pest Control Date",
    last_health_checkup_date: "Last Health Check-up Date",
    last_tank_cleaning_date: "Last Tank Cleaning Date",
    last_water_quality_testing_date: "Last Water Quality Testing Date",
  },
  home: {
    'findCanteen': "Find Canteens",
    'subtitle': "Select location details to fetch the list of canteens.",
    'district': "District",
    'municipality': "Municipality",
    'ward': "Ward",
    'canteenType': "Canteen Type",
    'searchCanteens': "Search Canteens",
    'searching': "Searching...",
    'startSurvey': "Start Survey",
    'viewSurvey': "View Survey",
    'searchResults': "Search Results",
  },
  survey: {
    'fullAddInput': "Full Address of the Facility",
    'instruction1':'Tap a section to fill — complete all to submit',
    'save&continue': "Save & continue →",
    'saving': "Saving...",
    'saveSection': "Save Section",
    'submitSurvey': 'Submit Survey',
    'backtosection': "← Back",
  },
  surveyForms: {
    kiosk: {
      title: "Kiosk Survey",
      description: "Assessment of Maa Canteen Kiosk"
    },
    kitchen: {
      title: "Kitchen Survey",
      description: "Assessment of Maa Canteen Kitchen"
    },
    'kitchen-cum-dining': {
      title: "Kitchen Cum Dining Survey",
      description: "Assessment of Maa Canteen Kitchen Cum Dining"
    }
  },
  settings: {
    title: "Settings",
    subtitle: "Manage your account information.",
    signedInAccount: "Signed in account",
    noUserDetails:"No user details available for this account.",
    surveyLanguage: "Survey Language",
    selectLanguage: "Select Language",
    languageDescription:"Questions will appear in the selected language.",
    logout: "Logout",
    user: "User",
    notAvailable: "Not available",
    yes: "Yes",
    no: "No",
    english: "English",
    bengali: "বাংলা",
  },
  location: {
    title: "Location Settings",
    subtitle:"Allow location access so the website can use your current position when needed.",
    accessEnabled: "Location access enabled",
    accessRequired: "Location access required",
    accessBlocked: "Location access blocked",
    accessUnsupported: "Location is not supported",
    requesting: "Requesting location access",
    permissionTitle: "Location Permission",
    permissionDescription:"Location is needed across this website for location-based workflows.",
    browserPermissionMessage:"Click the button to allow location access from your browser.",
    accessDescription:"Click the button to allow location access from your browser.",
    notNow: "Not now",
    checking: "Checking...",
    close: "Close",
    allowLocation: "Allow Location",
    latitude: "Latitude",
    longitude: "Longitude",
    accuracy: "Accuracy",
    meters: "meters",
    manualTitle: "Turn on location manually",
    chromeTitle: "Chrome or Edge",
    chromeDescription:"Click the lock icon in the address bar, open Site settings, set Location to Allow, then refresh this page.",
    firefoxTitle: "Firefox",
    firefoxDescription:"Click the location icon in the address bar, clear the blocked permission, then request location again.",
    androidTitle: "Android",
    androidDescription:"Open browser settings, go to Site settings, choose Location, and allow this website.",
    iosTitle: "iPhone or iPad",
    iosDescription:"Open Settings, choose the browser, turn Location on, then allow this website when prompted.",
  },
  navbar:{
    logo: "MAA Canteen Monitoring",
    logoShort: "MAA Canteen",
    wbgovt: "GOVERNMENT OF WEST BENGAL",
    home: "Home",
    survey: "Survey",
    settings: "Settings",
  }
};